import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import Text from '../../../Text'
import { Widget } from '../../../Widget'
import { useApplicantProfileContext } from '../RentalPortalApplicantProfile.hooks'

import { ApplicantProfileWidgetStageScreeningGroup } from './ApplicantProfileWidgetStageScreeningGroup'
import { ApplicantProfileWidgetStageScreeningSkeleton } from './ApplicantProfileWidgetStageScreeningSkeleton'
import { ApplicantProfileWidgetStageScreeningStage } from './ApplicantProfileWidgetStageScreeningStage'
import { QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING } from './RentalPortalApplicantProfileWidgetStageScreening.constants'
import {
  getApplicantStageScreeningGroups,
  getIsApplicantInPool,
} from './RentalPortalApplicantProfileWidgetStageScreening.utils'

import * as styles from './RentalPortalApplicantProfileWidgetStageScreening.module.css'

function RentalPortalApplicantProfileWidgetStageScreening() {
  const { t } = useTranslation()

  const locale = useDateLocale()

  const timezone = useTimeZone()

  const { applicantData, isInitiated } = useApplicantProfileContext()

  const groups = getApplicantStageScreeningGroups({
    applicantData,
    locale,
    t,
    timezone,
  })

  return (
    <Widget
      contentContainerProps={{
        Skeleton: ApplicantProfileWidgetStageScreeningSkeleton,
        className: styles.content,
      }}
      headerProps={{ contentProps: { actionsProps: { EditButton: null } } }}
      isSkeleton={!isInitiated || !applicantData}
      qaName={QA_NAME_APPLICANT_PROFILE_WIDGET_STAGE_SCREENING}
      title={t('RentalPortal.ApplicantProfileStageScreeningWidgetTitleKey')}
    >
      <ApplicantProfileWidgetStageScreeningStage stage={applicantData?.stage} />
      {getIsApplicantInPool(applicantData) ? (
        <Text isSecondary className={styles.poolHint}>
          {t('RentalPortal.ApplicantProfileScreeningPoolHintKey')}
        </Text>
      ) : (
        groups.map(({ key, ...group }) => (
          <ApplicantProfileWidgetStageScreeningGroup {...group} key={key} />
        ))
      )}
    </Widget>
  )
}

export default RentalPortalApplicantProfileWidgetStageScreening
